import { Resolver, ResolverError, ResolverSuccess } from 'react-hook-form';
import { ZodSchema, ZodTypeDef } from 'zod';
import { experimentalValidateWithZod, validateWithZod, validateWithZodAsync } from '../validation';

export const createZodFormResolver = <Output extends object, Input extends object = Output>(
    schema: ZodSchema<Output, ZodTypeDef, Input> | (() => ZodSchema<Output, ZodTypeDef, Input>)
) =>
    ((values) => ({
        values,
        errors: validateWithZod(schema)(values, {}),
    })) satisfies Resolver<Output>;

export const createAsyncZodFormResolver = <Output extends object, Input extends object = Output>(
    schema: ZodSchema<Output, ZodTypeDef, Input> | (() => ZodSchema<Output, ZodTypeDef, Input>)
) =>
    (async (values) => ({
        values,
        errors: await validateWithZodAsync(schema)(values, {}),
    })) satisfies Resolver<Output>;

/**
 * Experimental resolver to return transformed values via the schema transformation
 */
export const createExperimentalZodFormResolver = <Output extends object, Input extends object = Output>(
    schema: ZodSchema<Output, ZodTypeDef, Input> | (() => ZodSchema<Output, ZodTypeDef, Input>)
) =>
    ((values) => {
        const validated = experimentalValidateWithZod(schema)(values, {});
        return {
            values: { ...values, ...validated.values },
            errors: validated.errors,
        };
    }) satisfies (values: Input) => ResolverSuccess<Output> | ResolverError<Input>;
